import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useEffect } from 'react';
import useIMask from './use-imask.js';

var _excluded = ["value", "unmaskedValue", "setUnmaskedValue"];
var useInputMask = function useInputMask(_ref, ref) {
  var maskConfig = _ref.maskConfig,
      originalValue = _ref.originalValue,
      onChange = _ref.onChange;

  var _useIMask = useIMask(ref, {
    opts: maskConfig,
    onAccept: onChange
  }),
      value = _useIMask.value,
      unmaskedValue = _useIMask.unmaskedValue,
      setUnmaskedValue = _useIMask.setUnmaskedValue,
      maskProps = _objectWithoutPropertiesLoose(_useIMask, _excluded);

  useEffect(function () {
    if (originalValue !== null && originalValue !== undefined) {
      setUnmaskedValue(originalValue);
    }
  }, [originalValue]);
  return _extends({
    value: value,
    unmaskedValue: unmaskedValue
  }, maskProps);
};

export { useInputMask };
